import {ProfileModalView} from "./profile-modal.view";
import PropTypes, {InferProps} from "prop-types";
import {useState} from "react";
import {ProfileModalForm} from "./profile-modal.form";
import {currentPerson, currentProfile, usePerson, usePersonView, useProfile} from "@betrue/front/services";
import {CircularProgress} from "@mui/material";
import {Person, Profile} from "@betrue/shared/interfaces";

export const ProfileModalPropsTypes = {
  cancelButton: PropTypes.string,
  submitButton: PropTypes.string,
  dialogHeader: PropTypes.string,
  dialogDescription: PropTypes.string,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  availabilityLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  availableLabel: PropTypes.string,
  notAvailableLabel: PropTypes.string,
  portfolioLabel: PropTypes.string,
  phoneLabel: PropTypes.string,

}
export type ProfileModalProps = InferProps<typeof ProfileModalPropsTypes>

export const ProfileModal = (props: ProfileModalProps) => {

  const [open, setOpen] = useState(false);
  const [viewPerson, viewProfile] = usePersonView()
  const [, {updatePerson}] = usePerson<Person>(currentPerson)
  const [, {updateProfile}] = useProfile<Profile>(currentProfile)


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmitProfile = (pf: ProfileModalForm) => {

    updatePerson({
      ...viewPerson,
      firstName: pf.firstName,
      lastName: pf.lastName,
      email: pf.email,
      phone: pf.phone,
      profile: null
    })
    updateProfile({
      ...viewProfile,
      available: pf.availability,
      price: pf.price,
      portfolio: pf.portfolio,
      person: null
    })
    setOpen(false)
  }

  if (!viewProfile || !viewPerson) return (<><CircularProgress/></>)

  return (
    <ProfileModalView
      profile={viewProfile}
      person={viewPerson}
      onSubmit={onSubmitProfile}
      submitButton={props.submitButton}
      dialogHeader={props.dialogHeader}
      cancelButton={props.cancelButton}
      dialogDescription={props.dialogDescription}
      firstNameLabel={props.firstNameLabel}
      lastNameLabel={props.lastNameLabel}
      emailLabel={props.emailLabel}
      priceLabel={props.priceLabel}
      availabilityLabel={props.availabilityLabel}
      availableLabel={props.availableLabel}
      notAvailableLabel={props.notAvailableLabel}
      phoneLabel={props.phoneLabel}
      portfolioLabel={props.portfolioLabel}
      handleClose={handleClose}
      handleClickOpen={handleClickOpen}
      isOpen={open}
    />
  )
}
ProfileModal.propTypes = ProfileModalPropsTypes

